<script>
  import Tray, { DismissTrayButton, SUCCESS } from '@commercebear/components/Tray';
  import LinkButton from '@commercebear/components/LinkButton';
  import Button from '@commercebear/components/Button';
  import { types } from '@commercebear/portal-api';
  import { useJobsDialog } from '../JobsDialogProvider';
  import { getStores } from '$app/stores';

  const {
    feature: {
      TASKS_V2,
    },
  } = types;

  export let jobType;
  export let tray = undefined;

  const { page } = getStores();
  const { features } = $page.data.session;
  const canViewTaskHistoryPage = features.includes(TASKS_V2);

  const jobsDialog = useJobsDialog();

  function onClick() {
    tray.dismiss();
    $jobsDialog.show();
  }
</script>

<Tray bind:tray appearance={SUCCESS}>
  {jobType} Started

  <svelte:fragment slot="actions">
    {#if canViewTaskHistoryPage}
       <LinkButton appearance='secondary' href='/tasks'>View Tasks</LinkButton>
    {:else}
      <Button on:click={onClick}>
        View Tasks
      </Button>
    {/if}
    <DismissTrayButton/>
  </svelte:fragment>
</Tray>
